document.addEventListener("turbolinks:load", function() {
  editor = "";
  editor2 = "";

  if ($("#recommend_campaign_setting_element_pc_html").length > 0) {
    editor = ace.edit("recommend_campaign_setting_element_pc_html");
    editor.session.setMode("ace/mode/html");
    editor.setTheme("ace/theme/twilight");
  
    // タブのスペース数を設定
    editor.getSession().setTabSize(2);
  
    // セッションの変更時のイベントを監視
    editor.session.on('changeAnnotation', function() {
      let annotations = editor.session.getAnnotations() || [], i = len = annotations.length;
      while (i--) {
        if(/important/.test(annotations[i].text)) { // !importantに関する警告をチェック
          annotations.splice(i, 1);
        }
      }
      if (len > annotations.length) {
        editor.session.setAnnotations(annotations);
      }
    });
  }

  if ($("#recommend_campaign_setting_element_sp_html").length > 0) {
    editor2 = ace.edit("recommend_campaign_setting_element_sp_html");
    editor2.session.setMode("ace/mode/html");
    editor2.setTheme("ace/theme/twilight");
  
    // タブのスペース数を設定
    editor2.getSession().setTabSize(2);
  
    // セッションの変更時のイベントを監視
    editor2.session.on('changeAnnotation', function() {
      let annotations = editor2.session.getAnnotations() || [], i = len = annotations.length;
      while (i--) {
        if(/important/.test(annotations[i].text)) { // !importantに関する警告をチェック
          annotations.splice(i, 1);
        }
      }
      if (len > annotations.length) {
        editor2.session.setAnnotations(annotations);
      }
    });
  }
  

  $('.recommend_campaign_setting_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_campaign_setting_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.recommend_campaign_setting_slidedown_btn').fadeIn(0));
  });

  $('.recommend_campaign_setting_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_campaign_setting_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.recommend_campaign_setting_slideup_btn').fadeIn(0));
  });

  // ------------------------------------------------------------------------------------------------
  // 個別キャンペーン設定
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // 個別キャンペーン設定の切り替え
  // #################################################################
  $('.recommend_campaign_setting_selects').on('change', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    if (recommend_campaign_setting_id == 'new') {
      $('.recommend_campaign_setting_set_wrapper_display').css('display', 'block');
      $('.recommend_campaign_setting_name_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_pc_show_valid_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_sp_show_valid_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_url_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_excluded_url_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_pc_html_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_sp_html_setting_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_gender_segment_flag_wrapper').css('display', 'none');
      $('.recommend_campaign_setting_loyalty_segment_flag_wrapper').css('display', 'none');
    } else {
      location.href = `/recommend_campaign_setting/index?recommend_campaign_setting_id=${recommend_campaign_setting_id}`;
    }
  });
  // #################################################################
  // 個別キャンペーン設定の新規作成
  // #################################################################
  $('#recommend_campaign_setting_create').on('click', function () {
    const name = $('.recommend_campaign_setting_input').val();
    
    if (!name) {
      alert('設定名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/recommend_campaign_setting/create_recommend_campaign_setting',
      type: 'POST',
      data: {
        name: name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('新規登録されました。');

        location.href = `/recommend_campaign_setting/index?recommend_campaign_setting_id=${data.recommend_campaign_setting_id}`;
      }
    });
  });

  // #################################################################
  // 個別キャンペーン設定名の編集
  // #################################################################
  $('#recommend_campaign_setting_name_edit_btn').on('click', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let name = $('.recommend_campaign_setting_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_name',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 個別キャンペーン設定の公開設定(PC)
  // #################################################################
  $('.recommend_campaign_setting_pc_show_valid_select_box').on('change', function (event) {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let pc_show_valid = $('.recommend_campaign_setting_pc_show_valid_select_box:checked').val();

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_pc_show_valid',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        pc_show_valid: pc_show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 個別キャンペーン設定の公開設定(SP)
  // #################################################################
  $('.recommend_campaign_setting_sp_show_valid_select_box').on('change', function (event) {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let sp_show_valid = $('.recommend_campaign_setting_sp_show_valid_select_box:checked').val();

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_sp_show_valid',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        sp_show_valid: sp_show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 個別キャンペーン設定の公開設定(SP)
  // #################################################################
  $('.recommend_campaign_setting_sp_show_valid_select_box').on('change', function (event) {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let show_valid = $('.recommend_campaign_setting_sp_show_valid_select_box:checked').val();

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_sp_show_valid',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ユーザーセグメント設定
  // #################################################################
  $('.recommend_campaign_setting_gender_segment_flag_select_box').on('change', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let gender_segment_flag = $('.recommend_campaign_setting_gender_segment_flag_select_box:checked').val();

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_gender_segment_flag',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        gender_segment_flag: gender_segment_flag
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ロイヤリティセグメント設定
  // #################################################################
  $('.recommend_campaign_setting_loyalty_segment_flag_select_box').on('change', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let loyalty_segment_flag = $('.recommend_campaign_setting_loyalty_segment_flag_select_box:checked').val();

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_loyalty_segment_flag',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        loyalty_segment_flag: loyalty_segment_flag
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
      
    });
  });

  // #################################################################
  // フリーケンシー設定
  // #################################################################
  $('#recommend_campaign_days_after_display').on('change', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let days_after_display = $('#recommend_campaign_days_after_display').val();

    if (!days_after_display || days_after_display < 0) {
      alert("0より大きい数値を設定して下さい。");
    }

    $.ajax({
      url: '/recommend_campaign_setting/save_recommend_campaign_setting_days_after_display',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        days_after_display: days_after_display
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // html設定(pc)
  // #################################################################
  $('#recommend_campaign_setting_element_pc_html_set').on('click', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();

    let pc_html = editor.getValue();
    
    $.ajax({
      url: '/recommend_campaign_setting/create_recommend_campaign_setting_pc_html',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        pc_html: pc_html
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });
  // #################################################################
  // html設定(sp)
  // #################################################################
  $('#recommend_campaign_setting_element_sp_html_set').on('click', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();

    let sp_html = editor2.getValue();
    
    $.ajax({
      url: '/recommend_campaign_setting/create_recommend_campaign_setting_sp_html',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        sp_html: sp_html
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 個別キャンペーン設定の表示URL設定
  // #################################################################
  $('#recommend_campaign_setting_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="recommend_campaign_setting_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="recommend_campaign_setting_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.recommend_campaign_setting_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.recommend_campaign_setting_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#recommend_campaign_setting_url_set').on('click', function () {
    const recommend_campaign_setting_type_data = $(".recommend_campaign_setting_type_data").data("setting_type");
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let urls = [];
    $('.recommend_campaign_setting_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/recommend_campaign_setting/set_recommend_campaign_setting_url',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  //  個別キャンペーン設定の除外URL設定
  // #################################################################
  $('#recommend_campaign_setting_excluded_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="recommend_campaign_setting_excluded_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="recommend_campaign_setting_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.recommend_campaign_setting_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.recommend_campaign_setting_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#recommend_campaign_setting_excluded_url_set').on('click', function () {
    let recommend_campaign_setting_id = $('.recommend_campaign_setting_selects option:selected').val();
    let urls = [];
    $('.recommend_campaign_setting_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/recommend_campaign_setting/set_recommend_campaign_setting_excluded_url',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // ------------------------------------------------------------------------------------------------
  // 分析
  // ------------------------------------------------------------------------------------------------
  function recommend_campaign_update_url() {
    const recommend_campaign_setting_id = $('#recommend_campaign_metric_selects option:selected').val();
    const gf = $('#recommend_campaign_metric_graph_pattern_select_input').val();
    const start_day = $('#recommend_campaign_metric_report_start_day').val();
    const end_day = $('#recommend_campaign_metric_report_end_day').val();
    const device = $('.recommend_campaign_metric_device_select').data("device");

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (recommend_campaign_setting_id !== 'none' && recommend_campaign_setting_id !== null && recommend_campaign_setting_id !== undefined) {
      params.set('recommend_campaign_setting_id', recommend_campaign_setting_id);
    } else {
      params.delete('recommend_campaign_setting_id');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1" || device == "2") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // レコメンドコメンドューの選択
  // #################################################################
  $('#recommend_campaign_metric_selects').on('change', function () {
    recommend_campaign_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.recommend_campaign_metric_graph_pattern_select_day, .recommend_campaign_metric_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#recommend_campaign_metric_graph_pattern_select_input').val(gf_value);
    recommend_campaign_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.recommend_campaign_metric_device_select_all, .recommend_campaign_metric_device_select_pc, .recommend_campaign_metric_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.recommend_campaign_metric_device_select').data("device", device);
    recommend_campaign_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#recommend_campaign_metric_report_start_day, #recommend_campaign_metric_report_end_day').on('change', function () {
    recommend_campaign_update_url();
  });

  // #################################################################
  // レコメンドグデータのみの削除
  // #################################################################
  $('.delete_recommend_campaign_metric_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const recommend_campaign_setting_id = $('#recommend_campaign_metric_selects option:selected').val();

    $.ajax({
      url: '/recommend_campaign_report/delete_recommend_campaign_log',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // レコメンドグデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_recommend_campaign_metric_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const recommend_campaign_setting_id = $('#recommend_campaign_metric_selects option:selected').val();

    $.ajax({
      url: '/recommend_campaign_report/delete_recommend_campaign_log_and_related_data',
      type: 'POST',
      data: {
        recommend_campaign_setting_id: recommend_campaign_setting_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/recommend_campaign_report/index';
      }
    });
  });

  // #################################################################
  // レコメンドポートのcsv出力
  // #################################################################
  $('#download_recommend_campaign_metric_csv').on('click', function () {
    const recommend_campaign_setting_id = $('#recommend_campaign_metric_selects option:selected').val();
    const month = $('#ua_recommend_campaign_metric_month_selects option:selected').val();

    let href = '/download_recommend_campaign_metric_csv';

    href += `?recommend_campaign_setting_id=${recommend_campaign_setting_id}`;
    href += `&m=${month}`;
    location.href = href;
  });

  $('#ua_recommend_campaign_metric_month_selects').on('change', function () {
    let month = $('#ua_recommend_campaign_metric_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      location.reload();
    }
  });
});